/** What to call an artifact where people read it: the name it was shared
 *  under, else its summary, else its `[[name]]` id. */
export const artifactLabel = (
  name: string,
  preview: { summary: string | null } | undefined,
  pin: { display_name: string } | null
): string => pin?.display_name ?? preview?.summary ?? name;
